import { Activity } from "@ofqual/portal-activity-feed";
import { ActivityType } from "../../../domain/ActivityType";
import { News } from "../../../domain/News";
import { UpdatedDialog } from "./dialogs/UpdatedDialog";

type RenderDialogProps = {
  focussedEntity: Activity | null;
  onClose: () => void;
  newsItem: News;
};

export const RenderDialog: React.FC<RenderDialogProps> = ({
  focussedEntity,
  onClose,
  newsItem,
}) => {
  if (!focussedEntity) {
    return null;
  }

  const activity = focussedEntity as Activity;

  switch (activity.activityType) {
    case ActivityType.NewsUpdated:
      return <UpdatedDialog activity={activity} onClose={onClose} />;
    default:
      return null;
  }
};
